import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { SupportStepsModule } from 'src/app/components/support-steps/support-steps.module';

import { ChannelSelectorModule } from '../components/channel-selector/channel-selector.module';

import { OnboardingRoutingModule } from './onboarding-routing.module';
import { OnboardingComponent } from './onboarding.component';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, OnboardingRoutingModule, SupportStepsModule, ChannelSelectorModule],
  declarations: [OnboardingComponent],
})
export class OnboardingModule {}
